import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";

/**
 * Fullscreen spinner used as a ``<Suspense>`` fallback while
 * lazy-loaded chunks are loading.
 */
const FullscreenSpinner = (): JSX.Element => (
    <Flex flex="1" align="center" justify="center" minH="60vh">
        <Spinner size="xl" color="principal.blue" thickness="4px" speed="0.65s" />
    </Flex>
);

export default FullscreenSpinner;
